// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useEffect } from "react";

/**
 * Fetches Roboto the first time a task card preview mounts.
 *
 * The Action Tool renders its cards in Roboto, so the preview needs the face to be truthful — but
 * only the Tasks pages ever show a card. Requesting it from here rather than `index.html` keeps it
 * off the critical path for every other page; the document already carries preconnect hints for
 * the Google Fonts hosts, so the request starts warm.
 */
const HREF = "https://fonts.googleapis.com/css2?family=Roboto:wght@400..700&display=swap";

let requested = false;

export function useRobotoFont(): void {
  useEffect(function loadRobotoOnce() {
    if (requested || typeof document === "undefined") return;
    if (document.querySelector(`link[href="${HREF}"]`)) {
      requested = true;
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = HREF;
    document.head.appendChild(link);
    requested = true;
  }, []);
}
